import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FilesSheetIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.53 4.47L17.53 0.47C17.39 0.33 17.2 0.25 17 0.25H4C3.04 0.25 2.25 1.04 2.25 2V22C2.25 22.96 3.04 23.75 4 23.75H20C20.96 23.75 21.75 22.96 21.75 22V5C21.75 4.8 21.67 4.61 21.53 4.47ZM20.25 22C20.25 22.14 20.14 22.25 20 22.25H4C3.86 22.25 3.75 22.14 3.75 22V2C3.75 1.86 3.86 1.75 4 1.75H16.69L20.25 5.31V22Z"
        fill={color}
      />
      <path
        d="M6.38 10V18C6.38 18.34 6.66 18.62 7 18.62H17C17.34 18.62 17.62 18.34 17.62 18V10C17.62 9.65 17.34 9.38 17 9.38H7C6.65 9.38 6.38 9.66 6.38 10ZM7.62 14.62H11.37V17.37H7.62V14.62ZM12.62 17.38V14.63H16.37V17.38H12.62ZM16.38 13.38H12.63V10.63H16.38V13.38ZM11.38 10.62V13.37H7.63V10.62H11.38Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

FilesSheetIcon.displayName = 'FilesSheetIcon';
